import React, { useState } from "react"
import { Plus } from "lucide-react"
import { Button } from "src/components/ui/button"
import { Input } from "src/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select"

export function AddStageForm({ onAdd, isPending }) {
  const [open, setOpen] = useState(false)
  const [name, setName] = useState("")
  const [kind, setKind] = useState("open")
  const [probability, setProbability] = useState("")
  const [color, setColor] = useState("#94a3b8")

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!name.trim()) return
    try {
      await onAdd({ name: name.trim(), kind, probability: probability === "" ? null : Number(probability), color })
      setName("")
      setKind("open")
      setProbability("")
      setColor("#94a3b8")
      setOpen(false)
    } catch { /* toast handled upstream */ }
  }

  if (!open) {
    return (
      <Button variant="ghost" size="sm" className="mt-1 gap-1.5 text-slate-500" onClick={() => setOpen(true)}>
        <Plus className="h-3.5 w-3.5" /> Add stage
      </Button>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="mt-1 flex items-center gap-2 rounded-lg border border-dashed border-slate-200 bg-slate-50/50 px-3 py-2.5">
      <Input value={name} onChange={(e) => setName(e.target.value)} className="h-8 w-40" placeholder="Stage name" autoFocus />
      <Select value={kind} onValueChange={setKind}>
        <SelectTrigger className="h-8 w-24">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="open">Open</SelectItem>
          <SelectItem value="won">Won</SelectItem>
          <SelectItem value="lost">Lost</SelectItem>
        </SelectContent>
      </Select>
      <Input
        type="number" min="0" max="100" value={probability}
        onChange={(e) => setProbability(e.target.value)}
        className="h-8 w-20" placeholder="%"
      />
      <input type="color" value={color} onChange={(e) => setColor(e.target.value)} className="h-8 w-8 cursor-pointer rounded border" />
      <Button size="sm" type="submit" disabled={isPending || !name.trim()}>Add</Button>
      <Button size="sm" variant="ghost" type="button" onClick={() => setOpen(false)}>Cancel</Button>
    </form>
  )
}
